import { Reducer } from 'redux';

import { isActionOfType } from '../../../utils/action.utils';
import * as constants from './invoices.constants';
import * as types from './invoices.types';

const initialState: types.IInvoicesPageState = {
  invoiceIds: [],
  page: 1,
  limit: 10,
  total: 0,
  totalPages: 0,
};

export const invoicesPageReducer: Reducer<types.IInvoicesPageState, types.IInvoicesPageAction> = (
  state = initialState,
  action,
) => {
  if (isActionOfType<types.IStoreInvoicesList>(action, constants.STORE_INVOICES_LIST)) {
    return action.payload;
  }
  if (isActionOfType<types.IClearInvoicesPage>(action, constants.CLEAR_INVOICES_PAGE)) {
    return initialState;
  }
  return state;
};
